export type JsonRecord = Record<string, unknown>

export const asOptionalRecord = (value: unknown): JsonRecord | undefined =>
  value && typeof value === 'object' && !Array.isArray(value) ? value as JsonRecord : undefined

export const asRecord = (value: unknown): JsonRecord => asOptionalRecord(value) ?? {}

export const asOptionalString = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() ? value.trim() : undefined

export const asString = (value: unknown): string => String(value ?? '').trim()

export const asStringArray = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.filter((item): item is string => typeof item === 'string' && Boolean(item))
  }

  if (typeof value === 'string' && value.trim()) {
    try {
      return asStringArray(JSON.parse(value))
    } catch {
      return value.split(',').map((item) => item.trim()).filter(Boolean)
    }
  }

  return []
}

export const asOptionalStringArray = (value: unknown): string[] | undefined => {
  const strings = asStringArray(value)
  return strings.length ? strings : undefined
}

export const encodeBase64Utf8 = (value: string): string => {
  const bytes = new TextEncoder().encode(value)
  let binary = ''
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte)
  })
  return window.btoa(binary)
}

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  if (typeof error === 'string' && error.trim()) return error

  const data = asRecord((error as { response?: { data?: unknown } })?.response?.data ?? error)
  return (
    asString(data.error) ||
    asString(data.message) ||
    asString(data.detail) ||
    (error as Error)?.message ||
    fallback
  )
}

export const isValidEmail = (email: string): boolean => /\S+@\S+\.\S+/.test(email)

export const normalizeIndianMobile = (value: string): string => {
  const digits = value.replace(/\D/g, '')
  if (digits.length === 12 && digits.startsWith('91')) return digits.slice(2)
  if (digits.length === 11 && digits.startsWith('0')) return digits.slice(1)
  return digits.slice(0, 10)
}
